import React, { useState, useEffect } from "react";
import "../Scss/CaseStyles.scss?v=1.1.4";
import { Typography } from "antd";
import { TextField, Checkbox, Box } from "@mui/material/";
import { NavLink } from "react-router-dom";
const { Text } = Typography;

const EditCase = () => {
  const { host, hostname, href, origin, pathname, port, protocol, search } =
    window.location;

  const [caseElement, setCase] = useState("");

  const getCase = async (caseId) => {
    // console.log(caseId, 'Entrada GetCase Id');
    // let url = actualUrl + "/api/crm_companies_cases?token=" + token + "&objPerPage=" + postsPerPage + "&pagePressed=" + offset;
    // console.log( url, 'Entrada Cont 2' );
    // try {
    //   await api.post( url ).then((response) => {
    //     let dataCase = response.data['crm_cases'];
    //     let caseCount = response.data['casesCount'];
    //     // numero de paginas
    //     let pageCountBef = Math.ceil(caseCount / postsPerPage)
    //     pageCountBef = pageCountBef - 1; // sale una pagina de mas por eso el -1
    //     // console.log(postsPerPage, 'postsPerPage');
    //     // console.log(pageCountBef, 'pageCountBef');
    //     setPageCount(pageCountBef);
    //     setCase(dataCase);
    //     return dataCase;
    //   });
    // } catch (error) {
    //   console.log(error, 'error getCases');
    // }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(search);
    const caseId = urlParams.get("case");
    // console.log(urlParams.get('case'), 'search')
    if (caseId !== "" || caseId !== false || caseId !== undefined) {
      getCase(caseId);
    } else {
    }
  }, []);

  return (
    <div className="fatherContainer">
      <div className="viewHead">
        <h2 className="title">Expedientes</h2>
        <Text className="paragraph">
          <NavLink className="urlDirection" to={"/"}>
            Inicio
          </NavLink>{" "}
          /{" "}
          <NavLink className="urlDirection" to={"/expedientes"}>
            Expedientes
          </NavLink>{" "}
          / <b>Editar Expediente</b>
        </Text>
      </div>
      <Box
        component="form"
        sx={{ margin: "auto", "& > :not(style)": {} }}
        noValidate
        autoComplete="off"
        className="formMainContainer"
      >
        <TextField
          variant="outlined"
          className="inputFormCreate"
          label="Expediente Fisico"
        />
        <TextField
          variant="outlined"
          className="inputFormCreate"
          label="Despacho"
        />
        <TextField
          variant="outlined"
          className="inputFormCreate"
          label="Abogado"
        />
        <TextField
          variant="outlined"
          className="inputFormCreate"
          label="Autorizados INSS, banco...Etc"
        />
        <TextField
          variant="outlined"
          className="inputFormCreate"
          label="Cliente"
        />
        <div className="leftPosition litleMarginY fontSizeForExamplesOrTexts">
          <Checkbox color="success" />
          <span>
            {" "}
            El TITULAR del expediente NO es el mismo que Cliente/usuario.
          </span>
        </div>
        <TextField
          variant="outlined"
          className="inputFormCreate"
          label="Tipo de proceso"
        />
        <TextField
          variant="outlined"
          className="inputFormCreate"
          label="Hoja de encargo/Contrato"
        />
        <div className="centerPosition" style={{ marginTop: "10px" }}>
          <button className="redButton">
            {" "}
            <NavLink className="getOutFromViews" to={"/expedientes"}>
              Salir
            </NavLink>{" "}
          </button>
          <button className="greenButton" style={{ marginLeft: "15px" }}>
            {" "}
            Crear Expediente{" "}
          </button>
        </div>
      </Box>
    </div>
  );
};

export default EditCase;
